export const OfficeEmailTemplatesState = {
	url: '/email-templates',
	title: 'Office Email Templates',
	template: '<email-template-page></email-template-page>',
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeSettingsEmailPageMod" */
			'@Containers/office-email-template-page/settings-email.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
